/**
 * SANAL HESAP — arayüz yardımcıları (back-test, 14.10.2026). Hesap yok:
 * motor Worker'da (`packages/local/src/browser/sanal.ts`). Burada yalnızca
 * özet metinleri ve fiyat eşitleme çağrısı.
 */

import type { LocalRepository, SanalHesapTanimi } from "@parafon/contracts/local-api";
import type { CentralContextValue } from "../central/CentralContext";
import { araclariEsitle, type EsitlemeSonucu } from "./aracEsitle";
import { gunEkle } from "./seriYukle";
import { bugunYerelIso } from "./tarihDonemleri";
import { M } from "../dil";

/** Sanal hesabın varlıklarının fiyatı ve kuru: başlangıçtan bugüne. */
export function sanalVeriEsitle(
  repo: LocalRepository,
  merkez: Pick<CentralContextValue, "central" | "prices" | "sync">,
  tanim: SanalHesapTanimi,
  raporParasi?: string,
): Promise<EsitlemeSonucu> {
  const son = tanim.bitis != null && tanim.bitis < bugunYerelIso() ? tanim.bitis : bugunYerelIso();
  return araclariEsitle(repo, merkez, {
    instrumentIds: tanim.varliklar.map((v) => v.instrumentId),
    // Başlangıç bir hafta sonuna/tatile denk gelirse önceki kapanış gerekir.
    from: gunEkle(tanim.baslangic, -10),
    to: son,
    paralar: [tanim.paraBirimi, raporParasi ?? null],
  });
}

const DENGELEME_AD = {
  yok: M.sanal.ozet.dengelemeYok,
  alimla: M.sanal.ozet.dengelemeAlimla,
  satarak: M.sanal.ozet.dengelemeSatarak,
} as const;

/** Kuralın tek satırlık özeti (liste ve ana sayfa kartı). */
export function kuralOzeti(t: SanalHesapTanimi): string {
  const pa = t.paraAkisi;
  const akis =
    pa.tur === "duzenli"
      ? M.sanal.ozet.duzenli(pa.periyot.adim, pa.periyot.birim, pa.periyotTutari, t.paraBirimi)
      : M.sanal.ozet.defter;
  return `${M.sanal.ozet.satir(t.varliklar.length, akis, DENGELEME_AD[t.dengeleme])}${t.temettu === "yokSay" ? M.sanal.ozet.temettuHaric : ""}`;
}
